import { toast } from 'react-toastify';
import { get, isString, range, forEach } from 'lodash';

import { Highlight, toFormattedText } from 'components/text/Highlight';
import { Emoji } from 'components/elements/emoji';
import { toFormattedMessage } from 'components/utils/text';

import * as styled from './styles';

export const openFlashMessage = function openFlashMessage(
  messages,
  props = {}
) {
  return messages.context.map((message) => {
    const { detail, values = {} } = message;
    const formattedMsg = isString(detail) ? (
      toFormattedText(detail, props.highlight)
    ) : (
      <Highlight type={props.highlight} text={detail} values={values} />
    );
    const link = props.link ? (
      <styled.FlashLink onClick={props.link.onClick}>
        {toFormattedMessage(props.link.text)}
      </styled.FlashLink>
    ) : null;
    const randomIndex = Math.floor(Math.random() * 51);

    switch (messages.status) {
      case 'success':
        return toast.success(
          <span>
            <Emoji name={messages.emoji || 'rocket'} /> {formattedMsg} {link}
          </span>,
          { autoClose: get(props, 'autoClose', 5000), toastId: props.id }
        );
      case 'error': {
        return toast.error(
          <span>
            <Emoji
              name={props.validationError ? 'man-detective' : 'exploding-head'}
            />{' '}
            {formattedMsg} {link}
          </span>,
          {
            autoClose: get(props, 'autoClose', 11000),
            toastId:
              props.id ||
              (props.validationError
                ? `validation${randomIndex}`
                : `error${randomIndex}`),
          }
        );
      }
      case 'info':
        return toast.info(
          <span>
            <Emoji name={messages.emoji || 'light-bulb'} /> {formattedMsg}{' '}
            {link}
          </span>,
          { autoClose: get(props, 'autoClose', 5000), toastId: props.id }
        );
      default:
        return toast(
          <span>
            {formattedMsg} {link}
          </span>,
          {
            autoClose: get(props, 'autoClose', 5000),
            toastId: props.id,
          }
        );
    }
  });
};

export const closeFlashMessage = function closeFlashMessage(id) {
  toast.dismiss(id);
};

export const closeFlashMessages = function closeFlashMessages() {
  toast.dismiss();
};

export const closeValidationFlashMessages = function closeValidationFlashMessages() {
  forEach(range(50), (n) => toast.dismiss(`validation${n}`));
};
